import moneyString from '../moneyString.js'

function productCodesInTravelProtectionList (list) {
  return list.reduce((accumulator, item)=>{
    if (item) {
      if (accumulator[item.productCode]) {
        accumulator[item.productCode].quantity++
      } else {
        accumulator[item.productCode] = item
        accumulator[item.productCode].quantity=1
      }
    }
    return accumulator
  }, {})
}

function buildTravelProtectionEvents (newTravelProtections, oldTravelProtections, cartId) {

  function calculateValueDelta (quantityDelta, valueOfOne) {
    return moneyString(quantityDelta * valueOfOne)
  }

  function buildAddTravelProtectionEvent (travelProtectionProduct, newQuantity, oldQuantity, cartId) {
    return {
      "event": "addToCart",
      "cart_lines": [{
        "cart_id": cartId,
        "value": calculateValueDelta(newQuantity-oldQuantity, parseFloat(travelProtectionProduct.price)),
        "product": {
          "category": "Extras/Insurance",
          "id": travelProtectionProduct.productCode,
          "name": travelProtectionProduct.productCode,
          "quantity": `${newQuantity-oldQuantity}`,
          "value": moneyString(travelProtectionProduct.price),
        },
      }],
    }
  }

  function buildRemoveTravelProtectionEvent (travelProtectionProduct, newQuantity, oldQuantity, cartId) {
    return {
      "event": "removeFromCart",
      "cart_lines": [{
        "cart_id": cartId,
        "value": calculateValueDelta(oldQuantity-newQuantity, parseFloat(travelProtectionProduct.price)),
        "product": {
          "category": "Extras/Insurance",
          "id": travelProtectionProduct.productCode,
          "name": travelProtectionProduct.productCode,
          "quantity": `${oldQuantity-newQuantity}`,
          "value": moneyString(travelProtectionProduct.price),
        },
      }],
    }
  }

  function dedupe (list1, list2) {
    const deduped = []

    list1.forEach((item)=>{
      if(!deduped.includes(item)) {
        deduped.push(item)
      }
    })

    list2.forEach((item)=>{
      if(!deduped.includes(item)) {
        deduped.push(item)
      }
    })

    return deduped
  }

  const events = []

  const listOfNewTPs = productCodesInTravelProtectionList(newTravelProtections)
  const listOfOldTPs = productCodesInTravelProtectionList(oldTravelProtections)

  const listOfAllProductCodesWeveSeen = dedupe(Object.keys(listOfNewTPs), Object.keys(listOfOldTPs))
  listOfAllProductCodesWeveSeen.forEach((newProductCode)=>{
    const newQuantiy = listOfNewTPs[newProductCode]?listOfNewTPs[newProductCode].quantity:0
    const oldQuantity = listOfOldTPs[newProductCode]?listOfOldTPs[newProductCode].quantity:0
    if (newQuantiy > oldQuantity) {
      events.push(buildAddTravelProtectionEvent(listOfNewTPs[newProductCode], newQuantiy, oldQuantity, cartId))
    } else if (oldQuantity > newQuantiy) {
      events.push(buildRemoveTravelProtectionEvent(listOfOldTPs[newProductCode], newQuantiy, oldQuantity, cartId))
    }
  })

  return events
}

export default {
  eventsFor: (oldState, newState) => {
    const events = []

    const oldTravelProtection = oldState && oldState.cart ? oldState.cart.travelProtection : []
    const newTravelProtection = newState && newState.cart ? newState.cart.travelProtection.filter(Boolean) : []

    let travelProtectionsEqual = oldTravelProtection.length === newTravelProtection.length &&
      oldTravelProtection.every((o, idx) => o.productCode === newTravelProtection[idx].productCode)

    if(!travelProtectionsEqual) {
      const travelProtectionEvents = buildTravelProtectionEvents(newTravelProtection, oldTravelProtection, newState.cart.cartId)
      travelProtectionEvents.forEach((event)=>{
        events.push(event)
      })
    }

    return events
  },
  cartLinesFor (currentState) {
    const cartLines = []

    if (currentState.cart.travelProtection && currentState.cart.travelProtection.length>0) {

      const travelProtectionProducts = productCodesInTravelProtectionList(currentState.cart.travelProtection)

      Object.keys(travelProtectionProducts).forEach( (productCode)=>{
        const product = travelProtectionProducts[productCode]

        const cartLine = {
          "cart_id": currentState.cart.cartId,
          "product": {
            "category": "Extras/Insurance",
            "id": product.productCode,
            "name": product.productCode,
            "quantity": `${product.quantity}`,
            "value": `${moneyString(product.price)}`,
          },
          "value": `${moneyString(product.quantity * product.price)}`,
        }

        cartLines.push(cartLine)
      })
    }

    return cartLines
  },
}